import { Component } from '@angular/core';
import { ReportShareComponent } from '../../report-share.component';

@Component({
  selector: 'app-coachee-secondary-style',
  templateUrl: './coachee-secondary-style.component.html'
})
export class CoacheeSecondaryStyleComponent extends ReportShareComponent {

  get html(): string {
    return this.report?.secondaryCoachingStyleDesc?.replaceAll("\n","<br />") ?? '';
  }

}
